"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var Query_1 = require("./Query");
var GlobalQuery = /** @class */ (function (_super) {
    __extends(GlobalQuery, _super);
    function GlobalQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    GlobalQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, key = _a.key, keyQuery = _a.keyQuery, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ key: key,
            keyQuery: keyQuery }, (options.global || {}));
    };
    GlobalQuery.prototype.getRawValue = function (executionOptions, callStackLevel) {
        if (callStackLevel === void 0) { callStackLevel = 1; }
        var key = this.options.key;
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (key && context) {
            var globalQueries = context.globalQueries;
            if (globalQueries && Array.isArray(globalQueries)) {
                var globalQuery = globalQueries.find(function (globalQuery) { return globalQuery.queryId === key; });
                if (globalQuery) {
                    var query = new Query_1.Query(globalQuery, this.translationHelper, callStackLevel + 1);
                    return query.execute(executionOptions);
                }
            }
        }
        return;
    };
    return GlobalQuery;
}(BaseQuery_1.BaseQuery));
exports.GlobalQuery = GlobalQuery;
//# sourceMappingURL=GlobalQuery.js.map